import * as types from './actionTypes';

export function setProjectTitleState(projectTitle) {
    return {type: types.SET_PROJECT_TITLE, projectTitle};
}

export function setBiteTitleState(biteTitle) {
    return {type: types.SET_BITE_TITLE, biteTitle};
}

export function setScreenTitleState(screenTitle) {
    return {type: types.SET_SCREEN_TITLE, screenTitle};
}

export function setAudioRef(audio) {
    return {type: types.SET_AUDIO_REF, audio};
}

export function doUpdateFontSize(fontSize) {
    return {type: types.SET_FONT_SIZE, fontSize};
}

export function setCurrentAudioRef(currentAudioId) {
    return {type: types.SET_CURRENT_AUDIO_ID, currentAudioId};
}

export function setProjectTitle(projectTitle){
    return function (dispatch) {
        dispatch(setProjectTitleState(projectTitle));
    };
}

export function setBiteTitle(biteTitle){
    return function (dispatch) {
        dispatch(setBiteTitleState(biteTitle));
    };
}

export function setScreenTitle(screenTitle){
    return function (dispatch) {
        dispatch(setScreenTitleState(screenTitle));
    };
}

export function setAudio(audio){
    return function (dispatch) {
        dispatch(setAudioRef(audio));
    };
}

export function setCurrentAudio(currentAudioId){
    return function (dispatch) {
        dispatch(setCurrentAudioRef(currentAudioId));
    };
}

export function clearAudio(){
    return function (dispatch, getState) {
        const state = getState();
        let audio  = Object.assign({},state.audio,{
            audioRef:""
        });
        dispatch(setAudioRef(audio));
    };
}

export function updateFontSize(fontSize){
    return function (dispatch) {
        dispatch(doUpdateFontSize(fontSize));
    };
}




/** WEBPACK FOOTER **
 ** ./src/actions/appDataActions.js
 **/